export default __webpack_public_path__ + "static/media/LAYERS_crop.63f2e0e0.png";